<template>
  <div id="detail_teams_outer" class="row">

    <a href="#" class="col-xs-12 col-md-6" v-for="(item, index) in itemList">
      <div class="item">
        <img class="item-icon-img" v-if="item.imageUrl != null && item.imageUrl.length > 0" :src="item.imageUrl">
        <span class="item-icon-text" :style="{backgroundColor: item.color}" v-else>{{item.iconText}}</span>
        <span class="item-title">{{item.title}}</span>
      </div>
    </a>


  </div>
</template>

<script>
export default {
  name: "MatchDetailTeams",
  data() {
    return {
      itemList: [
        {
          title: '上海壹球成名信息技术有限公司',
          id: 'team_001',
          color: "#fc1a34",
          imageUrl: '',
          iconText: '上',
        },
        {
          title: '上海壹球成名信息技术有限公司',
          id: 'team_001',
          color: "#fc1a34",
          imageUrl: '',
          iconText: '上',
        },
        {
          title: '上海壹球成名信息技术有限公司',
          id: 'team_001',
          color: "#fc1a34",
          imageUrl: '',
          iconText: '上',
        },
        {
          title: '上海壹球成名信息技术有限公司',
          id: 'team_001',
          color: "#fc1a34",
          imageUrl: '',
          iconText: '上',
        },
        {
          title: '上海壹球成名信息技术有限公司',
          id: 'team_001',
          color: "#fc1a34",
          imageUrl: '',
          iconText: '上',
        },

      ],
    }
  }
}
</script>

<style scoped>

  #detail_teams_outer {
    box-shadow: 0 0 15px rgba(255,0,0, 0.15);
    margin-top: 30px;
    padding-left: 5%;
    padding-right: 5%;
    padding-top: 5vh;
    padding-bottom: 6vh;
  }

  #detail_teams_outer a {
    text-decoration: none;
    text-align: left;
    margin-top: 30px;
  }

  #detail_teams_outer .item {
    display: inline-block;
  }

  .item .item-icon-img, .item .item-icon-text {
    width: 50px;
    height: 50px;
    overflow: hidden;
    border-radius: 25px;
  }

  .item span {
    display: inline-block;
  }

  .item .item-icon-text {
    font-size: 3rem;
    font-weight: bold;
    color: white;
    line-height: 50px;
    text-align: center;
    vertical-align: middle;
  }

  .item .item-title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
    margin-left: 20px;
  }


</style>



// WEBPACK FOOTER //
// src/components/matches/MatchDetailTeams.vue